import React, { useContext } from 'react';
import { LanguageContext } from '../../index';
import CountUp from 'react-countup';

const FunFact = (props) => {
    const { language } = useContext(LanguageContext);
    const funFact = language === 'en'
        ? [
            {
                title: '160',
                subTitle: 'thousand',
                sts: 'm2',
            },
            {
                title: '630',
                subTitle: 'Set of',
                sts: 'stairs',
            },
            {
                title: '1400',
                subTitle: 'Completed',
                sts: 'Projects',
            },
            {
                title: '100',
                subTitle: '% happy',
                sts: 'Clients',
            },
        ]
        : [
            {
                title: '160',
                subTitle: 'tysięcy',
                sts: 'metrów kw.',
            },
            {
                title: '630',
                subTitle: 'Kompletów',
                sts: 'Schodów',
            },
            {
                title: '1400',
                subTitle: 'Ukończonych',
                sts: 'Realizacji',
            },
            {
                title: '100',
                subTitle: '% zadowolonych',
                sts: 'Klientów',
            },
        ];

    return (

        <section className={`success-section mb-115 ${props.fClass}`}>
            <div className="container">
                <div className="row">
                    {funFact.map((funfact, fitem) => (
                        <div className="col-xl-3 col-md-6" key={fitem}>
                            <div className="success-box">
                                <span className="count-text" data-stop={funfact.title}><CountUp end={funfact.title} enableScrollSpy /></span>
                                <div className="success-content">
                                    <h3>{funfact.subTitle}</h3>
                                    <h6>{funfact.sts}</h6>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <span id="counter" className='d-none' />
        </section>
    )
}

export default FunFact;